<template>
  <b-card no-body class="mb-2 mt-4  w-100 ">
            <slot></slot>
            <b-card-header v-on:click="changeAcording"  header-tag="header" class=" w-100 h-100 p-0" role="tab">
              <div  v-b-toggle="id" variant="info" class="head-mes">
                <div class="title-left pl-3">
                  <div class="title-colapse">{{title}}</div>
                </div>
                <div class="componente">
                <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
                <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
              </div>
              </div>
            </b-card-header>
            <b-collapse :id="id" :accordion="id" role="tabpanel" ref="testeacor">
              <b-card-body>
                <div  class="img-flex">
                  <div v-if="arquivoCarrecamento === false" class="img-flex">
                    <div  v-for="(data, index) in dataImg" v-bind:key="index" :class="{'img-body':true}">
                      <b-skeleton-img class="icone-img"></b-skeleton-img>
                    </div>
                  </div>
                  <div v-else class="img-flex">
                    <div   v-for="(data, index) in dataFiles" v-bind:key="index" :class="{'img-body':true}">
                      <div v-if="arquivoCarrecamento === true" v-on:click="$emit('imageDetails', data.id, data.arquivo.extensao)"  class="h-100">
                      <i v-if="data.arquivo.extensao == 'pdf'" style="font-size: 70px" class="fas fa-file-pdf icone"></i>
                      <i v-else-if="data.arquivo.extensao == 'mp4'" style="font-size: 70px" class="fas fa-video icone"></i>
                      <!-- <i v-else style="font-size: 70px" class="far fa-image icone"></i> -->
                      <img v-else class="icone-img"  :src="'data:image/jpeg;base64,' + data.arquivo.arquivo"/>
                      <div class="img-footer">
                        <div  class="img-title">{{data.arquivo.descricao == null ? 'N/D' : data.arquivo.descricao}}</div>
                      </div>
                      </div>
                      <div class="edit-img" v-on:click="$emit('removeImg',data)">
                        <i class="fas fa-times"></i>
                      </div>
                    </div>
                    <div>
                      <b-skeleton-img v-if="escondeArquivo === group" class="img-body"></b-skeleton-img>
                    </div>
                  </div>
                  <slot  v-if="flAdd == true" name="newPick"></slot>
                </div>
                <!-- <div v-else class="img-flex">
                    <div   v-for="data in dataImg" v-bind:key="data.id" class="img-body-pdf">
                      <i style="font-size: 70px" class="fas fa-file-pdf"></i>
                      <div  class="img-title" v-on:click="$emit('imageDetails', data.arquivo.arquivo, true)">{{data.arquivo.descricao == null ? 'N/D' : data.arquivo.descricao}}</div>
                      <div class="img-footer">
                      </div>
                      <div class="edit-img" v-on:click="$emit('removeImg',data.id)">
                        <i class="fas fa-times"></i>
                      </div>
                    </div>
                  <slot  v-if="flAdd == true" name="newPick"></slot>
                </div> -->
              </b-card-body>
            </b-collapse>
          </b-card>
</template>
<script>
import Colapseimage from './colapseimage'
export default Colapseimage
</script>

<style scoped>

.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.icone {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icone-img {
  height: 100%;
  border-radius: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-body-pdf{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.head-mes{
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
}

.img-flex{
  display: flex;
  width: 100%;
  column-gap: 1.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-start;
}
.title-colapse{
  padding-left: 15px;
}
.img-title{
  color: rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  z-index: 5;
  align-items: flex-end;
  font-weight: bold;
  width: 75%;
  padding-bottom: 7px;
}

.componente{
  font-size: 18px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}
.arrow-angel{
  font-size: 30px;
  color: black;
  padding-right: 20px;
  padding-bottom: 10px;
}
.img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
}
.pdf-body-add{
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-body:hover{
  transform: scale(1.1);
}

.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  background: rgba(0, 0, 0, 0.644);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}

.edit-img{
  height: 34px;
  top: 0px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.edit-img:hover{
   background-color: rgb(219, 7, 7);
}

.pencil-icon{
  z-index: 10;
}
.img-body:focus{
  transform: scale(1.5);

}
.img-body-pdf{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.img-body-info{
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.pdf-body-add{
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}

.img-body:hover{
  transform: scale(1.1);
}
.edit-img{
  height: 34px;
  top: 0px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  background: rgba(0, 0, 0, 0.644);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.addinput{
  height: 100%;
  width: 100%;
  position: absolute;
  visibility: hidden;
}
.modal-body{
  height: 100%;
  width: 100%;
  background: #01683a;
}
.img-body-dawnload{
  margin-left: 2%;
  width: 270px;
  height: 185px;
  font-size: 50px;
  color: grey;
  border-radius: 10px;
  position: relative;
  flex-direction: column;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px dotted grey;
}
.img-modal-details{
  height: 400px;
  /* object-fit: cover; */
  width: 100%;
}

.btn-new-gru{
  height: 30px;
  width: 181px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}
.btn-new-gru:hover{
  color: white;
  background: #008148;
}

.check-title{
  height: 20px;
  width: 20px;
  position: absolute;
  top: 8px;
  left: 5px;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/colapseimage/colapseimage.vue